module.exports = __webpack_public_path__ + "img/3.1f235bd5.svg";